import {
  BookOpen,
  CalendarCheck,
  FileText,
  LayoutDashboard,
  List,
  Receipt,
  User,
} from "lucide-react";

import { CAPABILITIES } from "@constants/capabilities";
import { NAVIGATION_PATHS } from "@constants/navigation";

export type NavigationItem = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  path: string;
  badge?: string;
  /** If set, the item shows only when the user has this capability (access
   *  levels v1). Undefined = visible to any authenticated user. */
  capability?: string;
};

export type NavigationGroup = {
  /** Section header shown above the group; omitted for ungrouped items. */
  section?: string;
  items: NavigationItem[];
};

export const NAVIGATION_GROUPS: NavigationGroup[] = [
  {
    items: [
      {
        id: "dashboard",
        label: "My Companion",
        icon: <LayoutDashboard className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.DASHBOARD,
      },
      // "New case" + "Cases" (referrer portal) are hidden for now — not in use
      // until the referrer portal ships (MDRS-157). Restore these two items then.
      // {
      //   id: "new-case",
      //   label: "New case",
      //   icon: <Plus className="size-5" strokeWidth={2} />,
      //   path: NAVIGATION_PATHS.NEW_CASE,
      //   capability: CAPABILITIES.CASES_CREATE,
      // },
      // {
      //   id: "cases",
      //   label: "Cases",
      //   icon: <List className="size-5" strokeWidth={2} />,
      //   path: NAVIGATION_PATHS.CASES,
      //   capability: CAPABILITIES.CASES_READ,
      // },
    ],
  },
  {
    section: "Report Assistant",
    items: [
      {
        // Report Studio (the report workspace). Gated by CASES_READ so both
        // doctors AND referrers see it — a referrer gets a doctor-style sidebar
        // but, of the report-assistant items, only Report Studio (Invoice Studio
        // and Resources stay gated out). The report template inside is still
        // hidden from referrers (TEMPLATES-gated in CaseOverview). (MDRS-157.)
        id: "report-studio",
        label: "Report Studio",
        icon: <FileText className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.REPORT_STUDIO,
        capability: CAPABILITIES.CASES_READ,
      },
      {
        id: "invoice-studio",
        label: "Invoice Studio",
        icon: <Receipt className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.INVOICE_STUDIO,
        capability: CAPABILITIES.INVOICE_STUDIO,
      },
      {
        id: "resources",
        label: "Resources",
        icon: <BookOpen className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.REPORT_TEMPLATES,
        capability: CAPABILITIES.TEMPLATES,
      },
    ],
  },
];

/**
 * Provider portal nav (MDRS-157). Shown instead of the referrer/expert nav when
 * the user is a `provider` — the records-provider fulfilment surface. Requests is
 * the working screen; Dashboard + Account are stubbed for now.
 */
export const PROVIDER_NAVIGATION_GROUPS: NavigationGroup[] = [
  {
    items: [
      {
        id: "provider-dashboard",
        label: "Dashboard",
        icon: <LayoutDashboard className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.PROVIDER_DASHBOARD,
      },
      {
        id: "provider-requests",
        label: "Cases",
        icon: <List className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.PROVIDER_REQUESTS,
      },
      {
        id: "provider-account",
        label: "Account",
        icon: <User className="size-5" strokeWidth={2} />,
        path: NAVIGATION_PATHS.PROVIDER_ACCOUNT,
      },
    ],
  },
];

/** Admin-only nav group (MDRS-102) — appended when the user is an admin. */
export const ADMIN_NAVIGATION_GROUP: NavigationGroup = {
  section: "Administration",
  items: [
    {
      id: "booking-approvals",
      label: "Booking Approvals",
      icon: <CalendarCheck className="size-5" strokeWidth={2} />,
      path: NAVIGATION_PATHS.BOOKING_APPROVALS,
    },
  ],
};
